import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _cloneDeep from "lodash/cloneDeep";
import _remove from "lodash/remove";
import _mapValues from "lodash/mapValues";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { checkSubqchoices, isSubqchoice, updateStructure } from '@mummssoftware/utils/form-engine/form-engine-utils';
import { statement, radio, checkbox, isonerequired } from './constants';
/**
 * cleanFormSubmission for Map Pain issue
 */

export const cleanFormSubmission = form => form.replaceAll('\\', '').replaceAll('"{', '{').replaceAll('}"', '}');
/**
 * create form data
 */

export const createFormData = formData => {
  let formdata = null;
  const autoSaveState = formData === null || formData === void 0 ? void 0 : formData.formsubmissionautosave;
  const previousSubmission = formData === null || formData === void 0 ? void 0 : formData.formsubmission; // autoSaveState is submitState (new autosave solution) or a string (old saving)

  if (autoSaveState) {
    // previous autosave send entire payload
    const isPreviousAutoSave = Array.isArray(JSON.parse(autoSaveState));

    if (!isPreviousAutoSave) {
      // if fallback data
      if (previousSubmission) {
        formdata = createAutoSaveForm(previousSubmission, autoSaveState);
      } else {
        formdata = null;
      }
    } else {
      formdata = (formData === null || formData === void 0 ? void 0 : formData.formdefinition) || (formData === null || formData === void 0 ? void 0 : formData.formsubmissionautosave) || (formData === null || formData === void 0 ? void 0 : formData.formsubmission);
    }
  } else {
    formdata = (formData === null || formData === void 0 ? void 0 : formData.formdefinition) || (formData === null || formData === void 0 ? void 0 : formData.formsubmissionautosave) || (formData === null || formData === void 0 ? void 0 : formData.formsubmission);
  }
  /**
   * cleanFormSubmission for Map Pain issue
   */


  if (formdata && formdata !== '[null]') {
    const cleanFormData = cleanFormSubmission(formdata);
    let parsedData = null;

    try {
      parsedData = cleanFormData && JSON.parse(cleanFormData);
    } catch (e) {
      // catch JSON parse exceptions
      console.log('JSON PARSING ERROR', e);
    }

    const correctdata = parsedData && Array.isArray(parsedData) ? parsedData : null;

    if (correctdata) {
      const data = updateStructure(parsedData);
      return data;
    }

    return null;
  }

  return null;
};
/**
 * renderTreeStructure - NOT USED
 */

export const renderTreeStructure = (inputs, depthLevel = 0) => {
  const menuTree = inputs.reduce((seed, val) => {
    const hasOptions = checkSubqchoices(val);
    let subMenu;

    if (hasOptions) {
      const newDepthLevel = depthLevel + 1;
      subMenu = renderTreeStructure(val.subqchoices, newDepthLevel);
      seed[val.id] = subMenu;
    } else {
      seed[val.id] = {};
    }

    return seed;
  }, {});
  return menuTree;
};
/**
 * creates initGroupBoxStateData
 */

export const createInitState = data => data ? data.reduce((seed, val) => {
  if (val.questionpath) {
    if (seed[val.parentquestionpath]) {
      seed[val.parentquestionpath][val.questionpath] = false;
    } else {
      seed[val.parentquestionpath] = {
        [val.questionpath]: false
      };
    }
  }

  return seed;
}, {}) : null;
/**
 * creates initEditGroupBoxStateData for the editing version
 */

export const createEditInitState = (data, initseed) => data ? data.reduce((seed, val) => {
  // hasValue is a boolean
  const hasValue = isSubqchoice(val) || typeof val.value === 'string' && val.value !== 'false';

  if (hasValue) {
    // value for text input
    const value = isSubqchoice(val) ? true : val.value;
    const isText = !isSubqchoice(val);

    if (seed[val.parentquestionpath]) {
      seed[val.parentquestionpath][val.questionpath] = value;

      if (isText) {
        seed[val.questionpath] = value;
      } else {
        seed[val.questionpath] = {};
      }

      if (checkSubqchoices(val)) {
        createEditInitState(val.subqchoices, seed);
      }
    } else {
      seed[val.parentquestionpath] = {
        [val.questionpath]: value
      };
      seed[val.questionpath] = {};

      if (checkSubqchoices(val)) {
        createEditInitState(val.subqchoices, seed);
      }
    }
  }

  return seed;
}, initseed) : null;
export const createGolbalEditInitState = data => createEditInitState(data, {});
/**
 * FORMS SPECIFIC REQUIRED QUESTIONS
 */

/**
 * creates Parent Global Required State
 * NOT USED
 */

const createParentRequiredState = (data, initseed) => data ? data.reduce((seed, val) => {
  // required is a boolean
  const {
    required
  } = val;

  if (required) {
    seed[val.questionpath] = true;
  } else if (checkSubqchoices(val)) {
    createParentRequiredState(val.subqchoices, seed);
  }

  return seed;
}, initseed) : null;
/**
 * creates Parent Global Number Required Questions State
 */


const createParentRequiredQuestState = (data, initseed) => data ? data.reduce((seed, val) => {
  // required is a boolean
  const {
    required
  } = val;

  if (required) {
    seed[val.questionpath] = true;
  }

  return seed;
}, initseed) : null;

export const createParentGlobalRequiredQuestState = data => createParentRequiredQuestState(data, {});

const checkAllChildrenRadio = el => el.every(element => isRadioOrCheck(element)); // radio or checkboxes elements that are not required but have required children if selected


const createNonRequiredState = (data, initseed) => data && data.length ? data.reduce((seed, val) => {
  if (val) {
    // required is a boolean
    const {
      required
    } = val;

    if (isRadioOrCheck(val)) {
      if (checkSubqchoices(val)) {
        if (!required) {
          // children are ALL radio buttons or checkboxes
          if (checkAllChildrenRadio(val.subqchoices)) {
            createNonRequiredState(val.subqchoices, seed); // if children are not radio and required
          } else if (val.subqchoices[0].required) {
            seed[val.questionpath] = {
              controltype: val.controltype,
              parent: val.parentquestionpath,
              rule: val.rule,
              subqchoices: val.subqchoices
            };
          }
        } else {
          createNonRequiredState(val.subqchoices, seed);
        }
      }
    } else if (checkSubqchoices(val)) {
      createNonRequiredState(val.subqchoices, seed);
    }
  }

  return seed;
}, initseed) : null;

const createGlobalNonRequiredState = data => createNonRequiredState(data, {});
/**
 * creates Global Required State
 */


const createRequiredState = (data, initseed) => data && data.length ? data.reduce((seed, val) => {
  if (val) {
    // required is a boolean
    const {
      required
    } = val;

    if (isRadioOrCheck(val)) {
      if (required) {
        seed[val.questionpath] = {
          controltype: val.controltype,
          parent: val.parentquestionpath,
          rule: val.rule,
          subqchoices: val.subqchoices
        };
      }
    } else {
      if (required) {
        seed[val.questionpath] = {
          controltype: val.controltype,
          parent: val.parentquestionpath,
          rule: val.rule,
          subqchoices: val.subqchoices
        };

        if (checkSubqchoices(val)) {
          createRequiredState(val.subqchoices, seed);
        } // if first value not required go down the tree

      } else if (checkSubqchoices(val)) {
        createRequiredState(val.subqchoices, seed);
      }
    }
  }

  return seed;
}, initseed) : null;

const createGlobalRequiredState = data => createRequiredState(data, {});
/**
 * check Required State
 */


const isCheckboxRequired = el => el.controltype === checkbox && el.rule === isonerequired;

const isRadioOrCheck = el => el.controltype === radio || el.controltype === checkbox;

const isRadioOK = (el, submitted, required) => {
  if (submitted[el] === true) {
    if (!checkSubqchoices(el)) {
      return true;
    }

    const data = required[el].subqchoices;
    return checkRequired(data, submitted);
  }

  return false;
}; // TODO handle recursion differently


export const checkRequired = (data, submitted) => {
  // try to go by who is going to fail first
  // console.log('**submitted**', submitted);
  const required = data && createGlobalRequiredState(data); // console.log('**required**', required);

  const requiredArr = required && Object.entries(required);

  if (requiredArr.length) {
    // 1. check the radios first
    const radioRequiredKeys = requiredArr.reduce((seed, val) => {
      const path = val[0];
      const res = val[1];

      if (res.controltype === radio) {
        if (seed[res.parent]) {
          seed[res.parent].push(path);
        } else {
          seed[res.parent] = [path];
        }
      }

      return seed;
    }, {});
    const requiredRadioArr = Object.entries(radioRequiredKeys); // console.log('**requiredRadioArr**', requiredRadioArr);

    const checkRequiredRadioFunc = (array, state) => {
      const {
        length
      } = array;

      for (let index = 0; index < length; index += 1) {
        const val = array[index];
        const parent = val[0];
        const radios = val[1];

        if (state && state[parent]) {
          const hasRadio = radios.some(i => isRadioOK(i, submitted, required));

          if (!hasRadio) {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    };

    const checkRequiredRadio = requiredRadioArr.length ? checkRequiredRadioFunc(requiredRadioArr, submitted) : true; // console.log('**checkRequiredRadio**', checkRequiredRadio);
    // 2. check the checkbox types IF radios are OK

    if (checkRequiredRadio) {
      // checkbox control type with rule
      const checkboxRequiredKeys = requiredArr.reduce((seed, val) => {
        const path = val[0];
        const res = val[1];

        if (isCheckboxRequired(res)) {
          if (seed[res.parent]) {
            seed[res.parent].push(path);
          } else {
            seed[res.parent] = [path];
          }
        }

        return seed;
      }, {});
      const requiredCheckboxArr = Object.entries(checkboxRequiredKeys);
      const checkRequiredCheckbox = requiredCheckboxArr.length ? checkRequiredRadioFunc(requiredCheckboxArr, submitted) : true; // console.log('**checkRequiredCheckbox**', checkRequiredCheckbox);
      // 3. check all other control types if checkbox rule OK

      if (checkRequiredCheckbox) {
        // other control types BUT radio and SHARED checkboxes
        const requiredKeys = requiredArr.reduce((seed, val) => {
          const path = val[0];
          const res = val[1];
          const radioEl = res.controltype === radio;
          const sharedCheckbox = isCheckboxRequired(res);

          if (!radioEl && !sharedCheckbox) {
            seed.push(path);
          }

          return seed;
        }, []);

        const isSubKeySubmitted = key => submitted[key] === true || typeof submitted[key] === 'string' && submitted[key] !== '';

        const checkRequiredKeys = requiredKeys.every(i => isSubKeySubmitted(i)); // console.log('**requiredKeys**', requiredKeys);

        if (checkRequiredKeys) {
          // check non required state
          const nonRequired = data && createGlobalNonRequiredState(data); // console.log('**nonRequired**', nonRequired);

          const checkSubkeys = key => {
            // non required radio was checked and
            if (isSubKeySubmitted(key)) {
              // check there is length
              if (checkSubqchoices(nonRequired[key])) {
                // there are subqchoices
                const keyChoices = nonRequired[key].subqchoices;
                const subRequired = keyChoices.filter(x => x.required);

                if (subRequired.length) {
                  const isOK = checkRequired(subRequired, submitted);
                  return isOK;
                }

                return true;
              } // there are no subqchoices


              return true;
            }

            return true;
          };

          if (Object.keys(nonRequired).length) {
            // if state check
            const checkNonRequired = Object.keys(nonRequired).every(key => checkSubkeys(key));
            return checkNonRequired;
          }

          return true;
        }
      }
    }

    return false;
  }

  return true;
};
/**
 * END OF FORMS SPECIFIC REQUIRED QUESTIONS
 */

/**
 * creates GolbalDCInitState for the editing version
 */

const createDCInitState = (data, initseed) => data ? data.reduce((seed, val) => {
  // hasDC is a boolean
  const hasDC = val.dcdate;

  if (hasDC) {
    seed[val.questionpath] = true;
  } else if (checkSubqchoices(val)) {
    createDCInitState(val.subqchoices, seed);
  }

  return seed;
}, initseed) : null;

export const createGolbalDCInitState = data => createDCInitState(data, {});
/**
 * creates createEditInitSubmitState for the editing version
 */

export const createEditInitSubmitState = data => {
  if (data && Object.keys(data).length) {
    const seed = {};
    Object.keys(data).forEach(key => {
      if (typeof data[key] === 'string') {
        seed[key] = data[key];
      } else {
        seed[key] = true;
      }
    });
    return seed;
  }

  return null;
};
/**
 * creates createEditInitLabelState for the editing version
 */

export const createEditInitLabelState = data => {
  if (data && Object.keys(data).length) {
    const seed = {};
    Object.keys(data).forEach(key => {
      seed[key] = {
        expanded: true
      };
    });
    return seed;
  }

  return null;
};
/**
 * creates initSubmitGroupBoxState
 */

export const createInitSubmitState = data => data ? data.reduce((seed, val) => {
  if (val.questionpath) {
    seed[val.parentquestionpath] = false;
  }

  return seed;
}, {}) : null;
/**
 * creates initial ID array for the editing version
 */

const createInitIds = (data, initseed, depthLevel = 0) => data && Array.isArray(data) ? data.reduce((seed, val) => {
  // hasValue is a boolean
  const hasValue = isSubqchoice(val) || typeof val.value === 'string' && val.value !== 'false';

  if (hasValue) {
    if (seed[depthLevel]) {
      seed[depthLevel].push(val.questionpath);
    } else {
      seed[depthLevel] = [val.questionpath];
    }

    if (checkSubqchoices(val)) {
      const newDepthLevel = depthLevel + 1;
      createInitIds(val.subqchoices, seed, newDepthLevel);
    }
  }

  return seed;
}, initseed) : null;

export const createGlobalInitIds = data => createInitIds(data, []);
/**
 * update an item with specific ID in a tree structure
 * returns the tree structure
 */

export const updateElement = (obj, questionpath, state) => Array.isArray(obj) ? obj.map(o => updateElement(o, questionpath, state)) : obj.questionpath === questionpath ? _objectSpread(_objectSpread({}, obj), {}, {
  value: state[questionpath]
}) // found it and update value
: _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateElement(obj.subqchoices, questionpath, state)
} : {});
export const updateElementBis = (obj, questionpath, state // eslint-disable-next-line consistent-return
) => {
  let newObj;

  if (Array.isArray(obj)) {
    newObj = obj.map(o => updateElementBis(o, questionpath, state));
  } else {
    if (obj.questionpath === questionpath) {
      if (state[questionpath] === true && obj.dcdate) {
        if (checkSubqchoices(obj)) {
          const childObj = _objectSpread(_objectSpread({}, obj), {}, {
            value: state[questionpath],
            dcdate: null,
            // update all the children dcdate to NULL
            subqchoices: updateAllChildrenDCDatetoNull(obj.subqchoices)
          });

          return childObj;
        }

        const childObj = _objectSpread(_objectSpread({}, obj), {}, {
          value: state[questionpath],
          dcdate: null
        });

        return childObj;
      }

      const childObj = _objectSpread(_objectSpread({}, obj), {}, {
        value: state[questionpath]
      });

      return childObj;
    }

    const childObj = _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
      subqchoices: updateElementBis(obj.subqchoices, questionpath, state)
    } : {});

    return childObj;
  }

  return newObj;
};
/**
 * update an item with specific ID in a tree structure that has been dc
 */

export const updateDCElement = (obj, questionpath, date) => Array.isArray(obj) ? obj.map(o => updateDCElement(o, questionpath, date)) : obj.questionpath === questionpath ? _objectSpread(_objectSpread({}, obj), {}, {
  dcdate: date
}) // found it and update dcdate
: _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateDCElement(obj.subqchoices, questionpath, date)
} : {});
/**
 * update all Tree nodes to value false
 */

const updateAllChildrenElementToFalse = obj => Array.isArray(obj) ? obj.map(o => updateAllChildrenElementToFalse(o)) : _objectSpread(_objectSpread({}, obj), {}, {
  value: false
}, checkSubqchoices(obj) ? {
  subqchoices: updateAllChildrenElementToFalse(obj.subqchoices)
} : {});
/**
 * find when a node is false, update all children node to false,
 */


export const updateFalseNodes = obj => Array.isArray(obj) ? obj.map(o => updateFalseNodes(o)) : obj.value === false || obj.value === 'false' ? _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateAllChildrenElementToFalse(obj.subqchoices)
} : {}) : _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateFalseNodes(obj.subqchoices)
} : {});
/**
 * find when a controltype is STATEMENT and update value to true
 */

export const updateStatementNodes = obj => Array.isArray(obj) ? obj.map(o => updateStatementNodes(o)) : obj.controltype === statement ? _objectSpread(_objectSpread({}, obj), {}, {
  value: 'true'
}, checkSubqchoices(obj) ? {
  subqchoices: updateStatementNodes(obj.subqchoices)
} : {}) : _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateStatementNodes(obj.subqchoices)
} : {});
/**
 * update all Tree nodes to dcdate
 */

const updateAllChildrenDCElement = (obj, date) => Array.isArray(obj) ? obj.map(o => updateAllChildrenDCElement(o, date)) : _objectSpread(_objectSpread({}, obj), {}, {
  dcdate: date
}, checkSubqchoices(obj) ? {
  subqchoices: updateAllChildrenDCElement(obj.subqchoices, date)
} : {});
/**
 * update all nodes with null dcdate
 */


const updateAllChildrenDCDatetoNull = obj => Array.isArray(obj) ? obj.map(o => updateAllChildrenDCDatetoNull(o)) : _objectSpread(_objectSpread({}, obj), {}, {
  dcdate: null
}, checkSubqchoices(obj) ? {
  subqchoices: updateAllChildrenDCDatetoNull(obj.subqchoices)
} : {});
/**
 * find when a node dcdate is true and update all children with dc date
 */


export const updateChildDCNodes = (obj, date) => // the first one if the main array and dcdate is null for those [{Related},{Goal},{Interventions}]
Array.isArray(obj) ? // each object - main 3 objects - Related - Goal - Interventions
obj.map(o => updateChildDCNodes(o, date)) : obj.dcdate !== null ? _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateAllChildrenDCElement(obj.subqchoices, date)
} : {}) : _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateChildDCNodes(obj.subqchoices, date)
} : {});
/**
 * delete items that have been unselected
 */

const deleteElement = (obj, questionpath) => {
  Object.keys(obj[questionpath]).length && Object.keys(obj[questionpath]).forEach(childPath => {
    if (obj[childPath]) {
      deleteElement(obj, childPath);
      delete obj[childPath];
    }
  });
  delete obj[questionpath];
  return obj;
};

export const unselectElement = (obj, questionpath) => {
  obj[questionpath] = _mapValues(obj[questionpath], () => false);
  deleteElement(obj, questionpath);
};
/**
 * unselect Id
 */

export const unselectId = (updatedArray, depthLevel, questionpath) => {
  // for all level downs, splice it if includes questionpath
  for (let level = depthLevel + 1; level < updatedArray.length; level++) {
    const hasLevel = updatedArray[level] && updatedArray[level].length;

    if (hasLevel) {
      const toRemove = [];
      updatedArray[level].forEach(path => {
        if (path.includes(questionpath)) {
          toRemove.push(path);
        }
      });
      toRemove.length && _remove(updatedArray[level], n => toRemove.includes(n));
    }
  }

  return updatedArray;
};
/**
 * clean submitted state
 */

export const cleanSubmittedState = (state, path) => {
  // delete future children
  const newPath = `${path}->`;
  const keys = Object.keys(state);
  keys.forEach(key => {
    if (key.includes(newPath)) {
      delete state[key];
    }
  });
  return state;
};
/**
 * find radio parent
 */

export const getRadioParent = (parseddata, parentQuestionPath) => {
  const ids = parentQuestionPath.split('->'); // if there is length
  // we assume first items cannot be radio as no parent component

  const steps = ids.length - 1;

  if (steps > 0) {
    // initial ID
    const initialID = `${ids[0]}->${ids[1]}`; // first item is not through subqchoices

    const initialObj = parseddata.filter(data => data.questionpath === initialID);

    const getChildPath = (id, level, obj) => {
      const newId = `${id}->${ids[level]}`;
      const recObj = obj[0].subqchoices.filter(data => data.questionpath === newId);

      if (level < steps) {
        return getChildPath(newId, level + 1, recObj);
      }

      return recObj[0];
    };

    if (steps > 1) {
      const newLevel = 2;
      return getChildPath(initialID, newLevel, initialObj);
    }

    return initialObj[0];
  }

  return null;
};
/**
 * find all controltypes in the tree structure
 */

function flatten(ops, n) {
  ops.push(n.controltype);

  if (checkSubqchoices(n)) {
    [].reduce.call(n.subqchoices, flatten, ops);
  }

  return ops;
} // const node = JSON.parse(option.formdefinition);


export const getAllTypes = node => node.reduce(flatten, []);
/**
 * creates GolbalLabelState for the read only version
 */

export const createLabelState = (data, initseed) => data ? data.reduce((seed, val) => {
  seed[val.questionpath] = val.questionlabel;

  if (checkSubqchoices(val)) {
    createLabelState(val.subqchoices, seed);
  }

  return seed;
}, initseed) : null;
export const createGolbalLabelState = data => createLabelState(data, {});
/**
 * updateWhoStructure for the comma in read only mode
 */

export const updateWhoStructure = obj => Array.isArray(obj) && obj[0] ? obj.map(o => updateWhoStructure(o)) : obj ? obj.questionlabel === 'Who' ? _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateWho(obj.subqchoices)
} : {}) : _objectSpread(_objectSpread({}, obj), checkSubqchoices(obj) ? {
  subqchoices: updateWhoStructure(obj.subqchoices)
} : {}) : {};
/**
 * create a form submission from fallback data and submit state
 */

export const createAutoSaveForm = (previousformsubmission, submitState) => {
  const cleanFormData = previousformsubmission ? cleanFormSubmission(previousformsubmission) : null;

  if (cleanFormData) {
    const parsedData = JSON.parse(cleanFormData);

    if (Array.isArray(parsedData)) {
      const updatedData = updateStructure(parsedData);

      let newData = _cloneDeep(updatedData);

      const submitGroupBoxState = JSON.parse(submitState); // need to update the controltype STATEMENT value to true for backend to persist the data

      newData = updateStatementNodes(newData); // **** Update answers ****
      // for each key in submitGroupBoxState, find it in updatedData and update value of items

      Object.keys(submitGroupBoxState).forEach(key => {
        newData = updateElementBis(newData, key, submitGroupBoxState);
      }); // update children to false if parent element is false- EDIT version

      newData = updateFalseNodes(newData);
      const stringifyData = JSON.stringify(newData);
      return stringifyData;
    }

    return null;
  }

  return null;
};
/**
 * UI ORIENTED ANSWERS DISPLAY
 */
// get number of required questions
// ****** NOT USED ******

export const getReqCount = state => {// const ansQuest = Object.keys(state.ansQuest).length;
  // const { initCount } = state;
  // if (ansQuest) {
  //   const count = initCount - ansQuest;
  //   return count;
  // }
  // return initCount;
};

const updateWho = arr => {
  const lastIndex = arr.length - 1;
  const lastItem = arr[lastIndex];
  lastItem.lastItem = true;
  return arr;
};

const whoItemsUS = ['Patient', 'Caregiver(s)', 'Family', 'Facility', 'Other'];
const whoItemsES = ['Paciente', 'Cuidador(es)', 'Familia', 'Instalación', 'Otros'];
const goalTextUS = 'Goal will be achieved within';
const goalTextES = 'Meta se logrará dentro de';
const whoTextUS = 'Who';
const whoTextES = 'Quién';
const goalSummaryUS = 'Goals';
const goalSummaryES = 'Objetivos';
export const getReadOnlySelectText = (input, state) => {
  if (input.questionlabel === whoTextUS && input.nooutcome) {
    const label = state[input.parentquestionpath] || 'Goal';
    return `${label}: `;
  }

  if (input.questionlabel === whoTextES && input.nooutcome) {
    const label = state[input.parentquestionpath] || 'Objetivos';
    return `${label}: `;
  }

  if (input.questionlabel === whoTextUS || input.questionlabel === whoTextES) {
    return null;
  }

  if (input.questionlabel === goalTextUS) {
    const label = state[input.parentquestionpath] || 'Goal';
    return `: ${label} will be achieved within`;
  }

  if (input.questionlabel === goalTextES) {
    const label = state[input.parentquestionpath] || 'Meta';
    return `: ${label} se logrará dentro de`;
  }

  if (whoItemsUS.includes(input.questionlabel) && input.lastItem) {
    return `${input.questionlabel}`;
  }

  if (whoItemsUS.includes(input.questionlabel)) {
    return `${input.questionlabel}, `;
  }

  if (whoItemsES.includes(input.questionlabel) && input.lastItem) {
    return `${input.questionlabel}`;
  }

  if (whoItemsES.includes(input.questionlabel)) {
    return `${input.questionlabel}, `;
  }

  return input.questionlabel;
};